import '@repo/ui/src/css/bootstrap.scss';
import '@repo/ui/src/css/fontawesome.scss';
import '@repo/ui/src/css/metrica.scss';
import '@/css/index.scss';
// Bootstrap's JS by component, only what the dashboard uses: importing one turns on its `data-bs-*` attributes.
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/offcanvas';

import { initGoogleAnalytics } from '@repo/analytics/src/ga';
import { initDomFallback } from '@repo/utils/src/domFallback';
import { loadTawkToWhenIdle } from '@repo/utils/src/tawk.to';
import axios from 'axios';
import iziToast from 'izitoast';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';

import env from '@/env';
import { router } from '@/router';

import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import store from './store';

initDomFallback();

iziToast.settings({
  position: 'topCenter',
  maxWidth: 600,
  transitionIn: 'fadeInDown',
  transitionOut: 'fadeOutUp',
  transitionInMobile: 'fadeInDown',
  transitionOutMobile: 'fadeOutUp',
});

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const Root = () => {
  return (
    <StrictMode>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </StrictMode>
  );
};

initGoogleAnalytics(env.VITE_GA_KEY, { sendPageView: false });
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<Root />);

loadTawkToWhenIdle();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
